import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import { createSearchParams, useSearchParams, useNavigate } from 'react-router-dom';
import { objectToQueryString, apiHelper, baseUrl } from 'helpers/util';

import ColumnBox from 'components/ColumnBox';
import CardList from 'components/CardList';
import CardItem from 'components/CardItem';
import SmallestHeading from 'components/SmallestHeading';
import SmallHeading from 'components/SmallHeading';


export default function Form() {
    const navigate = useNavigate();
    const [ topics, setTopics ] = useState([]);

    const loadTopics = function() {
        const apiParams = {
            "doctype": "FOLK Training Topic",
            "fields": JSON.stringify(["name"]),
            "order_by": "name asc",
            "limit": 1000
        }
        apiHelper.get({ "url": `${baseUrl}/.netlify/functions/erp_api`,
            "params": apiParams })
        .then(response => {
            if (response.status) { setTopics(response.json.data); }
            else { console.log(response.json); }
        })
    }

    const openTopicReport = function(topic) {
        navigate({ "pathname": "/training_index/topic_report",
            "search": createSearchParams({ 'topic': topic }).toString() });
    }

    useEffect(function() {
        loadTopics();
    }, [])

    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center',
            padding: '15px' }}>
            <ColumnBox>
                <SmallHeading>Topics</SmallHeading>
                <CardList>
                    { topics.map(p => (
                        <CardItem sx={{ 'cursor': 'pointer' }}
                            onClick={() => openTopicReport(p.name)}>
                            <SmallestHeading>{p.name}</SmallestHeading>
                        </CardItem>
                    )) }
                </CardList>
            </ColumnBox>
        </Box>
    );
}
